import Italic from "@tiptap/extension-italic";
import { markInputRule, markPasteRule } from "@tiptap/core";

/**
 * Matches an italic to a *italic* on input.
 */
export const starInputRegex = /(?:^|\s)(\*(?!\||\s+\*)((?:[^*]+))\*(?!\s+\*))$/;

/**
 * Matches an italic to a *italic* on paste.
 */
export const starPasteRegex = /(?:^|\s)(\*(?!\||\s+\*)((?:[^*]+))\*(?!\s+\*))/g;

/**
 * Matches an italic to a _italic_ on input.
 */
export const underscoreInputRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;

/**
 * Matches an italic to a _italic_ on paste.
 */
export const underscorePasteRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;

// const inputRegex = /(?:^|\s)(\*([^*|][^*]*[^|*])\*)(?!\|)/g;
// const pasteRegex = /(?:^|\s)(\*([^*|][^*]*[^|*])\*)(?!\|)/g;

export const CustomItalic = Italic.extend({
  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex,
        type: this.type,
      }),
      markInputRule({
        find: underscoreInputRegex,
        type: this.type,
      }),
    ];
  },

  addPasteRules() {
    return [
      markPasteRule({
        find: starPasteRegex,
        type: this.type,
      }),
      markPasteRule({
        find: underscorePasteRegex,
        type: this.type,
      }),
    ];
  },
});
